import { Beacon } from "./Beacon.js";
import { SubscriptionRegistry } from "./SubscriptionRegistry.js";
export class MergedObservable {
    subscriptions = new SubscriptionRegistry();
    #emitter = Beacon.withEmitter();
    #completionCount = 0;
    #observables;
    #observer = {
        // The next method is triggered whenever any source observable emits a value.
        // This value is forwarded to the emitter, so the merged observable emits it as well.
        next: this.#emitter.next,
        // If any observable emits an error, propagate it to the emitter
        // and end the merged observable immediately.
        // No further values will be emitted after an error.
        error: this.#emitter.error,
        // The complete method tracks the completion of each observable.
        // Once all observables have completed, the emitter's complete method is called.
        // This ensures the merged observable completes only after all sources are done.
        complete: () => {
            this.#completionCount++;
            if (this.#completionCount === this.#observables.length) {
                this.#emitter.complete();
            }
        },
    };
    constructor(...observables) {
        this.#observables = observables;
        for (const observable of this.#observables) {
            this.subscriptions.add(observable.subscribe(this.#observer));
        }
    }
    get beacon() {
        return this.#emitter.beacon;
    }
}
